import { useState } from "react";
import {
  IoIosCloseCircleOutline,
  IoIosNotifications,
} from "react-icons/io";
import { CiSearch } from "react-icons/ci";

const AnimatedSearchBar = ({ handleInputChange }) => {
  const [searchClicked, setSearchClicked] = useState(false);

  return (
    <>
      {searchClicked ? (
        <div className="w-full  items-center flex justify-center gap-2 px-5">
          <div className="border border-black rounded-xl flex justify-between items-center text-sm py-2 px-5 w-full">
            <input
              onChange={handleInputChange}
              type="text"
              className="outline-none w-full"
              placeholder="Search here..."
            />
            <CiSearch />
          </div>
          <div
            className="text-2xl p-2 w-10 h-10 bg-slate-200 rounded-lg cursor-pointer"
            onClick={() => setSearchClicked(false)}
          >
            <IoIosCloseCircleOutline className="text-primary" />
          </div>
        </div>
      ) : (
        <div className="flex flex-row items-center mx-3  justify-between">
          <img
            className="object-cover h-[30px]"
            src="/static/media/logo.0b902054ab86a6253951.png "
            alt="logo"
          />
          <form className="flex items-center justify-center mt-4 gap-3 ml-20">
            <div className="text-2xl p-2 w-10 h-10 bg-slate-200 rounded-lg">
              <IoIosNotifications />
            </div>
            <div
              onClick={() => setSearchClicked(true)}
              className="bg-gray-200 h-10 w-10  text-2xl items-center justify-center cursor-pointer hover:text-white flex rounded-lg"
            >
              <CiSearch />
            </div>
          </form>
          {/* <Search2 /> */}
        </div>
      )}
    </>
  );
};

export default AnimatedSearchBar;
